export enum Podcasts {
  INTERRUPTOR = "interruptor",
}
